import { StandardReport } from '../../../models';
import { SideNavCategory } from '../../../components/side-nav';
import { formatSubCategoryName, insertSorted } from '../../../util';

export function buildReportCategories(
  standardReports: Array<StandardReport>,
): SideNavCategory<StandardReport> {
  const itemMap = new Map<string, SideNavCategory<StandardReport>>();
  return standardReports.reduce(
    (acc, report) => {
      let topLevelCategory = itemMap.get(report.category);

      // if top level category doesn't exist, add all levels
      if (!topLevelCategory) {
        topLevelCategory = {
          name: report.category,
          key: report.category,
          items: [],
          typeName: 'StandardReport',
          tag: report,
        };
        insertSorted(
          acc.items,
          topLevelCategory,
          (
            a: SideNavCategory<StandardReport>,
            b: SideNavCategory<StandardReport>,
          ) => a.tag.categoryOrder - b.tag.categoryOrder,
        );
        itemMap.set(report.category, topLevelCategory);
      }

      const subLevelCategoryMapKey = `${report.category}-${report.subCategory}`;
      let subLevelCategory = itemMap.get(subLevelCategoryMapKey);

      // if sub category doesn't exist, add all child levels
      if (!subLevelCategory) {
        subLevelCategory = {
          name: report.subCategory,
          key: report.subCategory,
          tag: report,
          items: [],
          typeName: 'StandardReport',
          formattedSearchText: formatSubCategoryName(
            report.category,
            report.subCategory,
          ),
        };
        topLevelCategory.items.push(subLevelCategory);
        itemMap.set(subLevelCategoryMapKey, subLevelCategory);
      }

      // if all categories exist, add field
      subLevelCategory.items.push({
        name: report.name,
        key: report.name,
        tag: report,
        parent: {
          // Create new object here instead of refering to subLevelCategory
          //   to prevent circle reference when stringify
          name: subLevelCategory.name,
          key: subLevelCategory.key,
        },
        typeName: 'StandardReport',
      });

      return acc;
    },
    {
      name: 'Reports',
      key: 'Reports',
      items: [],
    },
  );
}
